import { createVNode as a, mergeProps as n } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ImportOutlinedStandard.js";
import m from "../components/PfIcon.js";
const t = (r, o) => {
  const e = {
    ...r,
    ...o.attrs
  };
  return a(m, n(e, {
    icon: d
  }), null);
};
t.displayName = "ImportOutlinedStandard";
t.inheritAttrs = !1;
export {
  t as default
};
